import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CloudOffIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.70711 0.292893C2.31658 -0.0976311 1.68342 -0.0976311 1.29289 0.292893C0.902369 0.683417 0.902369 1.31658 1.29289 1.70711L4.4243 4.83851C1.55964 7.03184 0.36022 10.7779 1.30479 14.32C2.3686 18.3093 6.01013 21.0628 10.1376 21H20.5858L23.2929 23.7071C23.6834 24.0976 24.3166 24.0976 24.7071 23.7071C25.0976 23.3166 25.0976 22.6834 24.7071 22.2929L21.713 19.2988C21.7091 19.2948 21.7052 19.2909 21.7013 19.2871L6.72252 4.3083C6.71222 4.29754 6.70172 4.28703 6.69101 4.2768L2.70711 0.292893ZM5.85496 6.26918C3.5067 7.92678 2.46733 10.9174 3.23726 13.8047C4.06522 16.9095 6.90076 19.0519 10.1137 19.0001L10.1217 19H18.5858L5.85496 6.26918ZM9.82358 3.91201C9.87218 3.36187 10.3575 2.95528 10.9077 3.00388C14.4585 3.31753 17.4632 5.69089 18.6169 9.01355C20.5975 9.09144 22.7248 9.55646 24.1357 11.6834C25.2487 13.3614 25.4458 15.4859 24.6605 17.34C24.4451 17.8486 23.8583 18.0862 23.3497 17.8708C22.8411 17.6554 22.6035 17.0686 22.8189 16.56C23.3424 15.3239 23.211 13.9076 22.469 12.7889C21.4819 11.3008 19.9488 11 17.8697 11H17.0919L16.9005 10.2461C16.1684 7.36328 13.6945 5.25783 10.7317 4.99612C10.1816 4.94753 9.77499 4.46215 9.82358 3.91201Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CloudOffIcon = assignWithoutSideEffects(_CloudOffIcon, {
  componentId: 'CloudOffIcon',
});

export default CloudOffIcon;
